module.exports = __webpack_public_path__ + "img/bg-2.18066d5c.jpeg";